import React, { Dispatch, FunctionComponent, SetStateAction } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useMedia } from 'react-media-match';
import { Dimension, Product } from '@/src/interfaces';
import Card from '@/src/components/Card';
import Input from '@/src/components/ProductSelection/Input';
import EngravingInput from '@/src/components/EngravingInput';

const messages = defineMessages({
  madeToMeasureCardHeadline: {
    defaultMessage: 'Wunschmaße',
    id: 'compact-detailview.made-to-measure-card.headline',
  },
});

const renderMeasureDimensions = (
  product: Product,
  setEngravingValue: Dispatch<SetStateAction<string>>,
  setLengthValue: Dispatch<SetStateAction<number>>,
  setWidthValue: Dispatch<SetStateAction<number>>,
) => (
  <>
    {product.dimensions.map(
      (dimension: Dimension, index: number) =>
        dimension.type === 'INPUT' && (
          <Input
            dimension={dimension}
            key={dimension.displayName.concat(index.toFixed())}
            onChange={(value: number) => {
              switch (dimension.axisType) {
                case 'WIDTH':
                  setWidthValue(value);
                  break;
                case 'LENGTH':
                  setLengthValue(value);
                  break;
                default:
              }
            }}
          />
        ),
    )}
    {product.attributes?.engraving && (
      <EngravingInput
        engravingBlock={product.attributes?.engraving}
        forceMaxLength
        onChange={(value: string) => setEngravingValue(value)}
      />
    )}
  </>
);

interface MadeToMeasureProps {
  isMadeToMeasure: boolean;
  product: Product;
  setEngravingValue: Dispatch<SetStateAction<string>>;
  setLengthValue: Dispatch<SetStateAction<number>>;
  setWidthValue: Dispatch<SetStateAction<number>>;
}

export const MadeToMeasure: FunctionComponent<MadeToMeasureProps> = ({
  isMadeToMeasure,
  product,
  setEngravingValue,
  setLengthValue,
  setWidthValue,
}) => {
  const intl = useIntl();
  const isMobile = useMedia({ desktop: false, mobile: true, tablet: false });
  return isMobile ? (
    <Card
      contentPadding
      headline={isMadeToMeasure ? intl.formatMessage(messages.madeToMeasureCardHeadline) : ''}
    >
      <div data-testid="measure-dimension-wrapper">
        {renderMeasureDimensions(product, setEngravingValue, setLengthValue, setWidthValue)}
      </div>
    </Card>
  ) : (
    <div data-testid="measure-dimension-wrapper">
      {renderMeasureDimensions(product, setEngravingValue, setLengthValue, setWidthValue)}
    </div>
  );
};

export default MadeToMeasure;
